import React, { useEffect, useState } from 'react';
import Loader from "react-loader-spinner";
import LoadingProgress from 'react-js-loading-progress-bar';
import { FaSignOutAlt } from 'react-icons/fa';
import { FiRefreshCw } from 'react-icons/fi';



const timeout = 10000;

const CustomLoader = (props) => {
    const { color, height, progress, total, message, onLogOff, onRefresh } = props;
    const [ timedOut, setTimedOut ] = useState(false);

    useEffect(() => {
        setTimeout(() => setTimedOut(true), timeout);
    }, [])

    const handleSignOut = async () => {
        if (onLogOff) {
            await onLogOff();
        }
    }

    const handleRefresh = async () => {
        if (onRefresh) {
            await onRefresh();
        }
    }

    return (
        <div style={{
            flex: 1, 
            display: 'flex',
            flexDirection: 'column' ,
            justifyContent: 'center', 
            alignItems: 'center', 
            height: height ? height : '78vh'
        }}>
            <div className="dashboard-card-title">{message}</div>
            <LoadingProgress
                active={true}
                total={total}
                current={progress}
                visualOnly
                className="custom-loader"
            />
            {timedOut && (
                <div className="mt-3 text-center">
                    <div className="dashboard-card-title">This is taking longer than expected</div>
                        {onLogOff && (
                            <button className="nav-btn mr-3" style={{width: 150}} onClick={handleSignOut}>Sign Out <FaSignOutAlt/></button>
                        )}
                        {onRefresh && (
                            <button className="nav-btn" style={{width: 150}} onClick={handleRefresh}>Refresh <FiRefreshCw/></button>
                        )}
                </div>
            )}
        </div>
    )
}

export default CustomLoader;